import React from "react";
import InfoIcon from "../../../../../../../assets/images/info_icon_3.png";


function PriceGuarantees(props) {

    return (
        <div className="price-guarantee-card">
            <PriceGuarantee  >
                Pay only for complete sessions.
            </PriceGuarantee>
            <PriceGuarantee  >
                No charge for no-shows or dishonest respondents
            </PriceGuarantee>
            <PriceGuarantee >
                <span className="bold-600-text">Other issue?</span> Let us know and we won't charge you for that response.
            </PriceGuarantee>
        </div>
    )
}

function PriceGuarantee(props) {
    return (
        <div className="price-guarantee-row">
            <img src={InfoIcon} alt="info icon" height={16} width={16} />
            <div className="price-guarantee-text">
                {props.children}
            </div>
        </div>
    )
}

export default PriceGuarantees;